import React from 'react';
import { useSEO } from '../hooks/useSEO';
import Navbar from './Navbar';
import Pricing from './Pricing';
import Footer from './Footer';

const PricingPage = () => {
  useSEO({
    title: 'Τιμές & Πλάνα - TailClinic',
    description: 'Δείτε τα πλάνα και τις τιμές του TailClinic. Ξεκινήστε δωρεάν και αναβαθμίστε όταν είστε έτοιμοι. Χωρίς κρυφές χρεώσεις.',
    canonical: 'https://www.tailclinic.gr/pricing',
  });

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#1A202C'
    }}>
      <Navbar />
      <Pricing />
      <Footer />
    </div>
  );
};

export default PricingPage;
